import { useEffect, useState } from 'react'

/**
 * Confirmação ao mudar um filtro com um processamento rodando.
 *
 * O processamento segue com os filtros do clique; aplicar a mudança sem
 * cancelá-lo deixaria a API trabalhando à toa e o resultado chegaria com os
 * filtros velhos. Aqui a pessoa escolhe: continuar (a mudança é descartada) ou
 * cancelar o processamento e aplicar a mudança.
 */
export function ConfirmProcessChangeModal({ changing, running, onKeep, onCancelAndApply }: {
  /** O que está sendo mudado, com artigo: "o período", "a empresa". */
  changing: string[]
  /** Filtros do processamento em andamento, para a pessoa reconhecer qual é. */
  running: string | null
  onKeep: () => void
  onCancelAndApply: () => Promise<void>
}) {
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && !busy) onKeep()
    }
    globalThis.addEventListener('keydown', onKey)
    return () => globalThis.removeEventListener('keydown', onKey)
  }, [busy, onKeep])

  const what = changing.length <= 1
    ? changing.join('')
    : `${changing.slice(0, -1).join(', ')} e ${changing[changing.length - 1]}`

  return (
    <div className="modal-overlay active" onClick={() => !busy && onKeep()} role="presentation">
      <div
        className="modal-content"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="confirm-process-change-title"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: 480 }}
      >
        <div className="modal-header">
          <h2 id="confirm-process-change-title" style={{ margin: 0, fontSize: 17 }}>Há um processamento em andamento</h2>
          <button type="button" className="modal-close" onClick={onKeep} disabled={busy} aria-label="Fechar">×</button>
        </div>
        <div style={{ padding: '16px 24px', fontSize: 14, color: 'var(--ink-700, #374151)', lineHeight: 1.5 }}>
          {running && (
            <div style={{ fontSize: 12, color: 'var(--ink-500, #6b7280)', marginBottom: 10 }}>
              Processando: <strong>{running}</strong>
            </div>
          )}
          Mudar {what} agora cancela esse processamento — o resultado dele não vai aparecer.
          Depois é só clicar em <strong>Processar</strong> com os filtros novos.
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, padding: '12px 24px', borderTop: '1px solid var(--ink-200, #e5e8ee)' }}>
          <button type="button" className="btn" onClick={onKeep} disabled={busy} style={{ fontSize: 13 }}>
            Continuar processando
          </button>
          <button
            type="button"
            className="btn btn-primary"
            disabled={busy}
            onClick={async () => {
              setBusy(true)
              try {
                await onCancelAndApply()
              } finally {
                setBusy(false)
              }
            }}
            style={{ fontSize: 13 }}
          >
            {busy ? 'Cancelando...' : 'Cancelar e aplicar a mudança'}
          </button>
        </div>
      </div>
    </div>
  )
}
